"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data = {
    theme: 'dark',
};
function plugin(TUICore) {
    TUICore.setCommonStore(data);
}
function install(app) {
    console.log('app', app);
}
var TUIColor = {
    name: 'TUITheme',
    plugin: plugin,
    install: install,
};
exports.default = TUIColor;
